import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Loser } from "../types";

type GetLossReportsParams = {
	loserId?: string;
};

const fetchLossReportsById = async (loserId?: string): Promise<Loser> => {
	const response = await apiDal.post("/findreport/getloser", {
		loserId,
	});

	return response.data;
};

export const useGetLossReportById = ({ loserId }: GetLossReportsParams) => {
	return useQuery<Loser>({
		queryKey: ["getLossReportById", loserId],
		queryFn: () => fetchLossReportsById(loserId),
		refetchOnWindowFocus: false,
		refetchOnMount: true,
		enabled: !!loserId,
		select: (data): Loser => {
			return data;
		},
	});
};
